import { toast } from "react-toastify";
import { AttrGroupApi, AttrListApi, AttrMasterNameApi, BindAttrGroupApi } from "../Api/MasterApi/AddAdvFilterGroupAttrApi";
import { AssigneeMaster } from "../Api/MasterApi/AssigneeMaster";
import { fetchMaster } from "../Api/MasterApi/MasterApi";
import { fetchIndidualApiMaster } from "../Api/MasterApi/masterIndividualyApi"
import { AddTaskDataApi } from "../Api/TaskApi/AddTaskApi";
import { Avatar, AvatarGroup, Box, Chip, createTheme, Tooltip } from "@mui/material";
import { UAParser } from 'ua-parser-js';

// Utility function to get UserProfileData from both localStorage and sessionStorage
export const getUserProfileData = () => {
    try {
        const userProfileData = localStorage.getItem("UserProfileData") || sessionStorage.getItem("UserProfileData");
        return userProfileData ? JSON.parse(userProfileData) : null;
    } catch (error) {
        console.error("Error parsing UserProfileData:", error);
        return null;
    }
};

// output like 01/01/2023
export const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}
// output like 01 Jan 2023
export function formatDate2(dateStr) {
    const dateObj = new Date(dateStr);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString('default', { month: 'short' });
    const year = dateObj.getFullYear();
    return `${day} ${month} ${year}`;
}

// Output like: Jan 29, 2024 at 06:30 PM
export const formatDate3 = (date) => {
    if (!date) return '';

    const formattedDate = new Date(date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
    return formattedDate.replace(',', ' at');
};


export const formatDate4 = (date) => {
    if (!date) return 'N/A';
    try {
        const entryDate = new Date(date);
        if (isNaN(entryDate.getTime())) return 'Invalid Date';
        const formatted = entryDate.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZone: 'UTC'
        });
        return formatted;
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'N/A';
    }
};

export function formatDueTask(dateStr) {
    const now = new Date();
    const dueDate = new Date(dateStr);
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const target = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());

    const diffMs = target - today;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
        return "Today";
    }

    if (diffDays > 0 && diffDays <= 30) {
        return `${diffDays} day${diffDays > 1 ? "s" : ""}`;
    }
    return dateStr && cleanDate(dateStr) ? formatDate2(cleanDate(dateStr)) : '-';
}


export function getTimeLeft(dateString) {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const futureDate = new Date(dateString);
    const target = new Date(futureDate.getFullYear(), futureDate.getMonth(), futureDate.getDate());

    const diffMs = target - today;

    const formatDateTime = (date) =>
        date.toLocaleString("en-US", {
            day: "numeric",
            month: "short",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });

    if (diffMs < 0) return "Overdue";
    if (diffMs === 0) return formatDateTime(futureDate);

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const weeks = Math.floor(diffDays / 7);
    const months = Math.floor(diffDays / 30);
    const years = Math.floor(diffDays / 365);

    if (years > 0) return `in ${years} year${years > 1 ? "s" : ""}`;
    if (months > 0) return `in ${months} month${months > 1 ? "s" : ""}`;
    if (weeks > 0) return `in ${weeks} week${weeks > 1 ? "s" : ""}`;
    if (diffDays > 0) return `in ${diffDays} day${diffDays > 1 ? "s" : ""}`;

    return "Soon";
}

export function toISTDateTime(isoDate) {
    const istDate = new Date(isoDate).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
    return istDate;
}

// output like 01 Jan 1990 return ""
export function cleanDate(dateStr) {
    const defaultDates = [
        "1900-01-01T00:00:00",
        "1900-01-01T00:00:00.000Z",
    ];

    return defaultDates.includes(dateStr) ? "" : dateStr;
}

// Week 32 of 2025
// Starts on: Mon Aug 04 2025
// Ends on: Sun Aug 10 2025
export function getISOWeekInfo(inputDate) {
    const date = new Date(inputDate);
    if (isNaN(date)) {
        throw new Error("Invalid date input");
    }
    const current = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const day = current.getUTCDay() || 7;
    current.setUTCDate(current.getUTCDate() + 4 - day);
    const yearStart = new Date(Date.UTC(current.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil((((current - yearStart) / 86400000) + 1) / 7);
    const weekStart = new Date(current);
    weekStart.setUTCDate(current.getUTCDate() - (current.getUTCDay() || 7) + 1);
    const weekEnd = new Date(weekStart);
    weekEnd.setUTCDate(weekStart.getUTCDate() + 6);

    return {
        week: weekNo,
        year: current.getUTCFullYear(),
        startOfWeek: new Date(weekStart.toISOString().split('T')[0]),
        endOfWeek: new Date(weekEnd.toISOString().split('T')[0])
    };
}

export const ImageUrl = (data) => {
    const init = JSON.parse(sessionStorage.getItem('taskInit'));
    if (data && init) {
        const url = `${init.url_path}/${init.ukey}/${data.empphoto}`;
        return url;
    }
    return null;
};

// priority color
export const priorityColors = {
    low: {
        color: "#4caf50",
        backgroundColor: "#e8f5e9",
    },
    medium: {
        color: "#ff9800",
        backgroundColor: "#fff3e0",
    },
    high: {
        color: "#f44336",
        backgroundColor: "#ffebee",
    },
    'very high': {
        color: "#f44336",
        backgroundColor: "#ffebee",
    },
    urgent: {
        color: "#d32f2f",
        backgroundColor: "#ffcccb",
    },
    critical: {
        color: "#ffffff",
        backgroundColor: "#b71c1c",
    },
    normal: {
        color: "#212529",
        bgcolor: "#e2e6ea"
    },
};

// progress color
export const getStatusColor = (value) => {
    if (value === 0) {
        return "#f0f0f0"; // Soft violet for not started
    } else if (value > 0 && value < 10) {
        return "#a0c4ff"; // Light sky blue for very early progress
    } else if (value >= 10 && value < 50) {
        return "#ffb703"; // Orange for in-progress
    } else if (value >= 50 && value < 70) {
        return "#2196f3"; // Blue for almost complete
    } else if (value >= 70 && value <= 100) {
        return "#4caf50"; // Green for completed
    } else {
        return "#eeeeee"; // Default fallback color (light)
    }
};

export const getcolorsData = {
    red: {
        color: "#f44336",
        backgroundColor: "#ffebee",
    },
    green: {
        color: "#4caf50",
        backgroundColor: "#e8f5e9",
    },
    yellow: {
        color: "#ffeb3b",
        backgroundColor: "#fff9c4",
    },
    blue: {
        color: "#2196f3",
        backgroundColor: "#e3f2fd",
    },
    pink: {
        color: "#e91e63",
        backgroundColor: "#f8bbd0",
    },
    orange: {
        color: "#ff9800",
        backgroundColor: "#fff3e0",
    },
    purple: {
        color: "#9c27b0",
        backgroundColor: "#e1bee7",
    },
    cyan: {
        color: "#00bcd4",
        backgroundColor: "#e0f7fa",
    },
    indigo: {
        color: "#3f51b5",
        backgroundColor: "#e8eaf6",
    },
    teal: {
        color: "#009688",
        backgroundColor: "#b2dfdb",
    },
    brown: {
        color: "#795548",
        backgroundColor: "#d7ccc8",
    },
    gray: {
        color: "#9e9e9e",
        backgroundColor: "#f5f5f5",
    },
    white: {
        color: "#ffffff",
        backgroundColor: "#ffffff",
    },
    black: {
        color: "#000000",
        backgroundColor: "#000000",
    }
}

export function getPerformanceStatus(value) {
    const performance = typeof value === "string" ? parseFloat(value.replace("%", "")) : value;

    if (performance === 0) {
        return { meaning: "Not Started", color: "#616161", bgColor: "#eeeeee" }; // grey
    } else if (performance > 0 && performance < 50) {
        return { meaning: "In Progress (Slow)", color: "#ff9800", bgColor: "#fff3e0" }; // orange
    } else if (performance >= 50 && performance < 100) {
        return { meaning: "In Progress", color: "#2196f3", bgColor: "#e3f2fd" }; // blue
    } else if (performance === 100) {
        return { meaning: "On Track", color: "#4caf50", bgColor: "#e8f5e9" }; // green
    } else if (performance > 100 && performance <= 120) {
        return { meaning: "Slight Overrun", color: "#f44336", bgColor: "#ffebee" }; // light red
    } else if (performance > 120) {
        return { meaning: "Overrun - Needs Attention", color: "#b71c1c", bgColor: "#ffcdd2" }; // dark red
    }

    return { meaning: "Unknown", color: "#9e9e9e", bgColor: "#f5f5f5" };
}

export const statusColors = {
    "initialized": {
        color: "#1e88e5", // Blue - just added
        backgroundColor: "#bbdefb",
    },
    "completed": {
        color: "#388e3c", // Green - task done
        backgroundColor: "#dcedc8",
    },
    "running": {
        color: "#0277bd", // Blue - active
        backgroundColor: "#b3e5fc",
    },
    "meetings-srd": {
        color: "#3949ab", // Indigo - meeting-related
        backgroundColor: "#c5cae9",
    },
    "started": {
        color: "#6a1b9a", // Purple - process started
        backgroundColor: "#e1bee7",
    },
    "prototype": {
        color: "#00796b", // Teal - design phase
        backgroundColor: "#b2dfdb",
    },
    "selected": {
        color: "#8e24aa", // Purple - shortlisted
        backgroundColor: "#f3e5f5",
    },
    "srs": {
        color: "#5d4037", // Brown - documentation
        backgroundColor: "#d7ccc8",
    },
    "pending": {
        color: "#ffa000", // Amber - waiting
        backgroundColor: "#ffecb3",
    },
    "dev": {
        color: "#1976d2", // Blue - development
        backgroundColor: "#bbdefb",
    },
    "hold": {
        color: "#ef6c00", // Orange - paused
        backgroundColor: "#ffe0b2",
    },
    "beta-run uat": {
        color: "#0288d1", // Light Blue - testing
        backgroundColor: "#b3e5fc",
    },
    "hold-on-challenge": {
        color: "#f57c00", // Deep orange - challenge
        backgroundColor: "#ffe0b2",
    },
    "delivery": {
        color: "#43a047", // Green - deliverable
        backgroundColor: "#c8e6c9",
    },
    "cancelled": {
        color: "#d32f2f", // Red - removed  
        backgroundColor: "#ffcdd2",
    },
    "reschedule": {
        color: "#00796b", // Teal - design phase
        backgroundColor: "#b2dfdb",
    },
    "delayed": {
        color: "#d32f2f", // Red - removed  
        backgroundColor: "#ffcdd2",
    },
    "feedback": {
        color: "#3949ab", // Indigo - awaiting response
        backgroundColor: "#c5cae9",
    },
};

// Enhanced Color Master System with 35+ Light/Dark Variants
export const colorMaster = {
    "red": { "light": "#ffebee", "dark": "#c62828", "name": "Red" },
    "pink": { "light": "#fce4ec", "dark": "#ad1457", "name": "Pink" },
    "purple": { "light": "#f3e5f5", "dark": "#6a1b9a", "name": "Purple" },
    "deepPurple": { "light": "#ede7f6", "dark": "#4527a0", "name": "Deep Purple" },
    "indigo": { "light": "#e8eaf6", "dark": "#283593", "name": "Indigo" },
    "blue": { "light": "#e3f2fd", "dark": "#1565c0", "name": "Blue" },
    "lightBlue": { "light": "#e1f5fe", "dark": "#0277bd", "name": "Light Blue" },
    "cyan": { "light": "#e0f7fa", "dark": "#00838f", "name": "Cyan" },
    "teal": { "light": "#e0f2f1", "dark": "#00695c", "name": "Teal" },
    "green": { "light": "#e8f5e9", "dark": "#2e7d32", "name": "Green" },
    "lightGreen": { "light": "#f1f8e9", "dark": "#558b2f", "name": "Light Green" },
    "lime": { "light": "#f9fbe7", "dark": "#9e9d24", "name": "Lime" },
    "yellow": { "light": "#fffde7", "dark": "#f9a825", "name": "Yellow" },
    "amber": { "light": "#fff8e1", "dark": "#ff8f00", "name": "Amber" },
    "orange": { "light": "#fff3e0", "dark": "#ef6c00", "name": "Orange" },
    "deepOrange": { "light": "#fbe9e7", "dark": "#d84315", "name": "Deep Orange" },
    "brown": { "light": "#efebe9", "dark": "#4e342e", "name": "Brown" },
    "grey": { "light": "#fafafa", "dark": "#424242", "name": "Grey" },
    "blueGrey": { "light": "#eceff1", "dark": "#37474f", "name": "Blue Grey" },
    "black": { "light": "#f5f5f5", "dark": "#212121", "name": "Black" },
    "maroon": { "light": "#ffebee", "dark": "#5c0000", "name": "Maroon" },
    "forest": { "light": "#e8f5e9", "dark": "#1b5e20", "name": "Forest" },
    "navy": { "light": "#e8eaf6", "dark": "#00003f", "name": "Navy" },
    "slate": { "light": "#eceff1", "dark": "#4f606e", "name": "Slate" },
    "oceanBlue": { "light": "#e0f2f7", "dark": "#01579b", "name": "Ocean Blue" },
    "sand": { "light": "#f9f5ed", "dark": "#886f6f", "name": "Sand" },
    "charcoal": { "light": "#e0e0e0", "dark": "#2c3e50", "name": "Charcoal" },
    "skyBlue": { "light": "#e8faff", "dark": "#2980b9", "name": "Sky Blue" },
    "coralReef": { "light": "#fff3e0", "dark": "#e67e22", "name": "Coral Reef" },
    "roseQuartz": { "light": "#fbe9e7", "dark": "#d44e52", "name": "Rose Quartz" },
    "sageGreen": { "light": "#f1f8e9", "dark": "#6c7a59", "name": "Sage Green" },
    "mustard": { "light": "#fffde7", "dark": "#d4ac0d", "name": "Mustard" },
    "lilac": { "light": "#f3e5f5", "dark": "#a06ba8", "name": "Lilac" },
    "burgundy": { "light": "#ffebee", "dark": "#800020", "name": "Burgundy" },
    "cobalt": { "light": "#e3f2fd", "dark": "#004085", "name": "Cobalt" },
    "oliveDrab": { "light": "#f1f8e9", "dark": "#6b8e23", "name": "Olive Drab" },
    "rust": { "light": "#fbe9e7", "dark": "#b7410e", "name": "Rust" },
    "stoneGrey": { "light": "#eceff1", "dark": "#6c7a89", "name": "Stone Grey" },
    "midnightBlue": { "light": "#e8eaf6", "dark": "#191970", "name": "Midnight Blue" },
    "cerulean": { "light": "#e3f2fd", "dark": "#007BA7", "name": "Cerulean" }
};

// Legacy colors array for backward compatibility
export const colors = [
    "#FF5722", "#4CAF50", "#2196F3", "#FFC107", "#E91E63", "#9C27B0", "#3F51B5", "#00BCD4",
    "#FF9800", "#9E9E9E", "#795548", "#607D8B", "#8BC34A", "#FFEB3B", "#FF4081", "#673AB7",
    "#ff7f50", "#F44336", "#3F51B5", "#CDDC39", "#03A9F4", "#9C27B0", "#FF1744", "#00E5FF",
    "#9E9E9E", "#4CAF50", "#00BCD4", "#8B4513", "#6A5ACD", "#F08080", "#32CD32", "#FF6347"
];

export const getRandomAvatarColor = (name) => {
    const charSum = name
        ?.split("")
        ?.reduce((sum, char) => sum + char?.charCodeAt(0), 0);
    return colors[charSum % colors.length];
};

// Dynamic Priority Color Function
export const getDynamicPriorityColor = (priorityName, colorKey = null) => {
    // Get stored priority colors from sessionStorage
    const storedPriorityColors = JSON.parse(sessionStorage.getItem('priorityMasterColors') || '{}');

    if (colorKey && colorMaster[colorKey]) {
        return {
            color: colorMaster[colorKey].dark,
            backgroundColor: colorMaster[colorKey].light,
            colorKey: colorKey
        };
    }

    if (storedPriorityColors[priorityName?.toLowerCase()]) {
        const colorKey = storedPriorityColors[priorityName?.toLowerCase()];
        return {
            color: colorMaster[colorKey].dark,
            backgroundColor: colorMaster[colorKey].light,
            colorKey: colorKey
        };
    }

    // Fallback to existing priority colors
    return priorityColors[priorityName?.toLowerCase()] || priorityColors.normal;
};

// Dynamic Status Color Function
export const getDynamicStatusColor = (statusName, colorKey = null) => {
    // Get stored status colors from sessionStorage
    const storedStatusColors = JSON.parse(sessionStorage.getItem('statusMasterColors') || '{}');

    if (colorKey && colorMaster[colorKey]) {
        return {
            color: colorMaster[colorKey].dark,
            backgroundColor: colorMaster[colorKey].light,
            colorKey: colorKey
        };
    }

    if (storedStatusColors[statusName?.toLowerCase()]) {
        const colorKey = storedStatusColors[statusName?.toLowerCase()];
        return {
            color: colorMaster[colorKey].dark,
            backgroundColor: colorMaster[colorKey].light,
            colorKey: colorKey
        };
    }

    // Fallback to existing status colors
    return statusColors[statusName?.toLowerCase()] || { color: "#9e9e9e", backgroundColor: "#f5f5f5" };
};

// Auto Text Color Selection based on background
export const getContrastTextColor = (backgroundColor) => {
    // Convert hex to RGB
    const hex = backgroundColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return black for light backgrounds, white for dark backgrounds
    return luminance > 0.5 ? '#000000' : '#ffffff';
};

// Get all available color options for UI
export const getColorOptions = () => {
    return Object.entries(colorMaster).map(([key, value]) => ({
        key,
        name: value.name,
        light: value.light,
        dark: value.dark,
        preview: value.dark
    }));
};

// Get color options organized by categories
export const getColorOptionsByCategory = () => {
    const colors = getColorOptions();

    // Define light colors - colors with good contrast (based on priority/status colors)
    const lightColorKeys = [
        'yellow', 'lime', 'lightGreen', 'mint', 'cyan', 'lightBlue',
        'pink', 'coral', 'salmon', 'gold', 'amber',
        'silver', 'grey', 'tan'
    ];

    // Define dark colors - colors with strong, dark contrast
    const darkColorKeys = [
        'red', 'deepOrange', 'orange', 'brown', 'chocolate',
        'purple', 'deepPurple', 'indigo', 'blue', 'navy', 'royal',
        'teal', 'green', 'forest', 'emerald', 'olive',
        'crimson', 'maroon', 'violet', 'magenta', 'black', 'slate',
        'blueGrey', 'turquoise', 'lavender', 'khaki'
    ];

    const lightColors = colors.filter(color => lightColorKeys.includes(color.key));
    const darkColors = colors.filter(color => darkColorKeys.includes(color.key));

    return {
        light: lightColors,
        dark: darkColors,
        all: colors
    };
};

export const AdvancedMasterApiFunc = async () => {
    const filMasterRes = await AttrMasterNameApi();
    const filGroupRes = await AttrGroupApi();
    const filAttrRes = await AttrListApi();
    const filBindRes = await BindAttrGroupApi();
    if (filMasterRes?.rd?.length > 0 && filGroupRes?.rd?.length > 0 && filAttrRes?.rd?.length > 0 && filBindRes?.rd?.length > 0) {
        const mergedData = mergeFilterData(filMasterRes, filGroupRes, filAttrRes, filBindRes);
        const safeData = Array.isArray(mergedData) ? mergedData : [];
        sessionStorage.setItem('structuredAdvMasterData', JSON.stringify(safeData));
        return mergedData;
    }
}

// make structure master data function
export const fetchMasterGlFunc = async () => {
    try {
        const advMasterData = sessionStorage.getItem('structuredAdvMasterData');
        if (!advMasterData) {
            const mergedData = await AdvancedMasterApiFunc();
            const safeData = Array.isArray(mergedData) ? mergedData : [];
            sessionStorage.setItem('structuredAdvMasterData', JSON.stringify(safeData));
        }
        const AssigneeMasterData = JSON?.parse(sessionStorage.getItem('taskAssigneeData'));
        const AuthData = JSON?.parse(sessionStorage.getItem('taskInit'));
        const uniqueDepartments = new Set();
        let UserProfileData
        // Helper function to determine storage location based on remember me
        const setUserProfileData = (data) => {
            sessionStorage.setItem('UserProfileData', JSON?.stringify(data));
        };

        if (!AssigneeMasterData) {
            const assigneeRes = await AssigneeMaster();
            UserProfileData = assigneeRes?.rd?.find(item => item?.userid == AuthData?.appuserid);
            setUserProfileData(UserProfileData);
            assigneeRes?.rd?.forEach(item => {
                if (item.department) {
                    uniqueDepartments.add(item.department);
                }
            });
        } else {
            UserProfileData = AssigneeMasterData?.find(item => item?.userid == AuthData?.appuserid) ?? {};
            setUserProfileData(UserProfileData);
            AssigneeMasterData?.forEach(item => {
                if (item.department) {
                    uniqueDepartments.add(item.department);
                }
            });
        }
        const departmentArray = Array.from(uniqueDepartments).map((department, index) => ({
            id: index + 1,
            labelname: department
        }));
        sessionStorage.setItem('taskDepartments', JSON?.stringify(departmentArray));
        let masterData = JSON?.parse(sessionStorage.getItem('structuredMasterData'));
        if (!masterData || masterData?.length == 0) {
            masterData = await fetchMaster();
            sessionStorage.setItem('masterData', JSON?.stringify(masterData));
        }
        if (masterData?.rd && Array?.isArray(masterData?.rd)) {
            const structuredData = [];
            for (const item of masterData?.rd) {
                const { mode } = item;
                if (mode) {
                    const apiResponse = await fetchIndidualApiMaster({ mode });
                    let filteredData = apiResponse?.rd?.filter(row => row?.isdelete != 1) || [];
                    filteredData.sort((a, b) => {
                        if (a.displayorder !== b.displayorder) {
                            return a.displayorder - b.displayorder;
                        }
                        return a.labelname.localeCompare(b.labelname);
                    });
                    structuredData.push({
                        ...item,
                        rowdata: filteredData || []
                    });
                    sessionStorage.setItem(`${mode}Data`, JSON?.stringify(filteredData || []));
                }
            }
            sessionStorage.setItem('structuredMasterData', JSON?.stringify(structuredData));
        }
        return UserProfileData
    } catch (error) {
        console.error("Error fetching master data:", error);
    }
};

// task parentid when add suntask and delete
export const findParentTask = (tasks, selectedTaskId, parentTask = null) => {
    for (let task of tasks) {
        if (task.taskid === selectedTaskId) {
            return parentTask;
        }
        if (task.subtasks) {
            const foundParent = findParentTask(task.subtasks, selectedTaskId, task);
            if (foundParent !== null) {
                return foundParent;
            }
        }
    }
    return null;
};

// map key value in api
export function mapTaskLabels(data) {
    const labels = data?.rd[0];
    const tasks = data?.rd1;
    const labelMap = {};
    Object?.keys(labels)?.forEach((key, index) => {
        labelMap[index + 1] = key;
    });
    function convertTask(task) {
        let taskObj = {};
        for (let key in task) {
            if (task.hasOwnProperty(key)) {
                const label = labelMap[key];
                if (label) {
                    taskObj[label] = task[key];
                }
            }
        }
        if (task.subtasks) {
            try {
                const parsedSubtasks = JSON?.parse(task.subtasks);
                taskObj.subtasks = parsedSubtasks?.map(subtask => {
                    let subtaskObj = {};
                    for (let key in subtask) {
                        if (subtask?.hasOwnProperty(key)) {
                            const label = labelMap[key];
                            if (label) {
                                subtaskObj[label] = subtask[key];
                            }
                        }
                    }
                    return subtaskObj;
                });
            } catch (error) {
                console.error("Error parsing subtasks:", error);
            }
        }

        return taskObj;
    }
    let taskData = tasks?.map(task => convertTask(task))

    return taskData;
}

export function mapKeyValuePair(data) {
    const labels = data?.rd[0];
    const tasks = data?.rd1;
    const labelMap = {};
    Object.keys(labels).forEach((key, index) => {
        labelMap[index + 1] = key;
    });
    function convertTask(task) {
        let taskObj = {};
        for (let key in task) {
            if (task.hasOwnProperty(key)) {
                const label = labelMap[key];
                if (label) {
                    taskObj[label] = task[key];
                }
            }
        }
        return taskObj;
    }
    let taskData = tasks?.map((task) => convertTask(task));
    return taskData;
}

export const flattenTasks = (tasks, level = 0) => {
    return tasks?.reduce((flatList, task) => {
        const { subtasks, ...taskWithoutSubtasks } = task;

        flatList.push({ ...taskWithoutSubtasks, level });

        if (subtasks?.length > 0) {
            flatList = flatList.concat(flattenTasks(subtasks, level + 1));
        }

        return flatList;
    }, []);
};

export function transformAttachments(data) {
    const mimeTypes = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        webp: "image/webp",
        gif: "image/gif",
        jfif: "image/jfif",
        avif: "image/avif",
        svg: "image/svg+xml"
    };

    const result = {
        attachment: {},
        url: {}
    };

    data?.forEach(({ foldername, DocumentName, DocumentUrl }) => {
        const folder = foldername;
        const docUrls = (DocumentName || "").split(",").filter(Boolean);
        const urlLinks = (DocumentUrl || "").split(",").filter(Boolean);

        // Process attachments
        if (!result.attachment[folder]) result.attachment[folder] = [];
        docUrls.forEach(url => {
            const fileName = url.substring(url.lastIndexOf("/") + 1);
            const ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
            result.attachment[folder].push({
                url,
                extention: ext,
                fileName,
                fileType: mimeTypes[ext] || "application/octet-stream"
            });
        });

        // Process additional URLs
        if (urlLinks.length) {
            result.url[folder] = urlLinks;
        }
    });

    return result;
}

//Selectmenu custom styles
export const commonSelectProps = {
    select: true,
    fullWidth: true,
    size: "small",
    sx: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": {
                borderRadius: "8px",
            },
        },
    },
    SelectProps: {
        MenuProps: {
            PaperProps: {
                sx: {
                    borderRadius: "8px",
                    "& .MuiMenuItem-root": {
                        fontFamily: '"Public Sans", sans-serif',
                        color: "#444050",
                        margin: "5px 10px",
                        "&:hover": {
                            borderRadius: "8px",
                            backgroundColor: "#7367f0",
                            color: "#fff",
                        },
                        "&.Mui-selected": {
                            backgroundColor: "#80808033",
                            borderRadius: "8px",
                            "&:hover": {
                                backgroundColor: "#7367f0",
                                color: "#fff",
                            },
                        },
                    },
                },
            },
        },
    },
};

// DatePicker custom styles
export const customDatePickerProps = {
    slotProps: {
        popper: {
            sx: {
                "& .MuiDateCalendar-root": {
                    borderRadius: "8px",
                    fontFamily: '"Public Sans", sans-serif',
                },
                "& .MuiButtonBase-root, .MuiPickersCalendarHeader-label, .MuiPickersYear-yearButton": {
                    color: "#444050",
                    fontFamily: '"Public Sans", sans-serif',
                },
                "& .MuiPickersDay-root, .MuiPickersYear-yearButton": {
                    "&:hover": {
                        backgroundColor: "#7367f0",
                        color: "#fff",
                    },
                },
                "& .MuiPickersDay-root.Mui-selected, .Mui-selected ": {
                    backgroundColor: "#7367f0",
                    color: "#fff",
                },
                "& .MuiPickersDay-root.Mui-selected, .MuiPickersYear-yearButton:hover": {
                    backgroundColor: "#7367f0",
                    color: "#fff",
                },
            },
        },
    },
};

// TimePicker custom styles
export const customTimePickerProps = {
    slotProps: {
        popper: {
            sx: {
                "& .MuiClockPicker-root": {
                    fontFamily: '"Public Sans", sans-serif',
                },
                "& .MuiClockPicker-pin": {
                    backgroundColor: "#7367f0",
                },
                "& .MuiClockPicker-arrowSwitcher-button": {
                    color: "#444050",
                    "&:hover": {
                        backgroundColor: "#e6e6e6",
                    },
                },
                "& .MuiMultiSectionDigitalClock-root": {
                    backgroundColor: "#f9f9f9",
                },
                "& .MuiMultiSectionDigitalClockSection-item": {
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    fontSize: "13px",
                    "&:hover": {
                        backgroundColor: "#7367f0",
                        color: "#fff",
                    },
                },
                "& .MuiMultiSectionDigitalClockSection-item.Mui-selected": {
                    backgroundColor: "#7367f0",
                    color: "#fff",
                },
            },
        },
    },
};

// sticky DatePicker custom styles use calendar page
export const customDatePickerStyles = {
    '& .MuiPickersLayout-root': {
        minWidth: '300px',
        width: '300px',
        margin: '0 auto',
    },
    '& .MuiDatePickerToolbar-root': {
        padding: '10px !important',
    },
    '& .MuiPickersToolbar-content': {
        '& .MuiTypography-root': {
            fontSize: '24px'
        },
    },
    '& .MuiDateCalendar-root': {
        borderRadius: '8px',
        fontFamily: '"Public Sans", sans-serif',
        color: '#444050',
        margin: '0',
    },
    '& .MuiPickersYear-root': {
        '& .MuiPickersYear-yearButton': {
            fontFamily: '"Public Sans", sans-serif',
            color: '#444050',
            '&:hover': {
                backgroundColor: '#7367f0',
                color: '#fff',
                borderRadius: '50px',
            },
        },
    },
    '& .css-6mw38q-MuiTypography-root': {
        display: 'none',
    },
    '& .MuiPickersCalendarHeader-label': {
        fontFamily: '"Public Sans", sans-serif',
        color: "#444050",
    },
    '& .MuiPickersDay-root': {
        fontFamily: '"Public Sans", sans-serif',
        color: '#444050',
        '&:hover': {
            backgroundColor: '#7367f0',
            color: '#fff',
        },
    },
    '& .MuiPickersDay-root.Mui-selected': {
        backgroundColor: '#7367f0 !important',
        color: '#fff !important',
    },
    '& .MuiPickersDay-root.Mui-selected:hover': {
        backgroundColor: '#7367f0',
        color: '#fff',
    },
    '& .MuiPickersYear-yearButton.Mui-selected': {
        backgroundColor: '#7367f0 !important',
        color: '#fff !important',
    },
};

// Common TextField style properties
export const commonTextFieldProps = {
    fullWidth: true,
    size: "small",
    className: "textfieldsClass",
};

// Optimized conversion functions
const charMap = {
    "&": "ane",
    "%": "percent",
};

// Reverse the mapping for words to special characters
const wordMap = Object.fromEntries(
    Object.entries(charMap).map(([key, value]) => [value, key])
);

// Function to convert special characters to words (for API)
export function convertSpecialCharsToWords(str) {
    return str?.replace(/[&<>"'%$#!?=+\-*/\\^~]/g, (match) => charMap[match] || match);
}

// Function to convert words back to special characters (for UI)
export function convertWordsToSpecialChars(str) {
    return str?.replace(/\b(ane)\b/g, (match) => wordMap[match] || match);
}

export function showNotification({
    title = 'Itask',
    body = 'This is a default notification message!',
    icon = '/logo.webp',
    actions = [
        { action: 'open', title: 'Open Page' },
        { action: 'dismiss', title: 'Dismiss' }
    ],
    url = 'https://your-link-here.com',
    status,
    onAction
}) {
    if (status?.toLowerCase() === 'completed') return;

    if ('serviceWorker' in navigator && 'Notification' in window) {
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                navigator.serviceWorker.getRegistration().then((registration) => {
                    if (registration) {
                        registration.showNotification(title, {
                            body,
                            icon,
                            actions,
                            data: { url },
                            requireInteraction: true
                        });

                        // Optional: Listen to action events
                        navigator.serviceWorker.addEventListener('notificationclick', (event) => {
                            if (!event.action || !event.notification?.data) return;

                            if (event.action === 'open') {
                                event.notification.close();
                                window.open(event.notification.data.url, '_blank');
                                onAction?.('open');
                            }

                            if (event.action === 'dismiss') {
                                event.notification.close();
                                onAction?.('dismiss');
                            }
                        });
                    }
                });
            }
        });
    }
}

export const isTaskDue = (dateStr) => {
    const now = new Date();
    if (!dateStr) return false;
    const taskDate = new Date(dateStr);
    // Return true if task is due today or overdue (past due date)
    return taskDate <= now;
};

export const isTaskToday = (dateStr) => {
    const now = new Date();
    if (!dateStr) return false;
    const taskDate = new Date(dateStr);
    return (
        taskDate.getDate() === now.getDate() &&
        taskDate.getMonth() === now.getMonth() &&
        taskDate.getFullYear() === now.getFullYear()
    );
};

// Calculate days difference between current date and deadline date
export const getDaysFromDeadline = (deadlineDate) => {
    if (!deadlineDate || !cleanDate(deadlineDate)) {
        return null; // No deadline set
    }

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const deadline = new Date(deadlineDate);
    const targetDate = new Date(deadline.getFullYear(), deadline.getMonth(), deadline.getDate());

    const diffMs = targetDate - today;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return diffDays; // Positive for future dates, negative for overdue dates, 0 for today
};

export const getCategoryTaskSummary = (nestedData = [], taskCategory = []) => {
    // Flatten recursive tasks and subtasks
    const flattenTasks = (tasks) => {
        let result = [];

        for (const task of tasks) {
            result.push(task);
            if (Array.isArray(task.subtasks) && task.subtasks.length > 0) {
                result = result.concat(flattenTasks(task.subtasks));
            }
        }
        return result;
    };
    const flatData = flattenTasks(nestedData);

    const isValidDate = (dateStr) => {
        const date = new Date(dateStr);
        return dateStr && date.toISOString().slice(0, 10) !== "1900-01-01";
    };

    const isToday = (dateStr) => {
        if (!isValidDate(dateStr)) return false;
        const date = new Date(dateStr);
        const today = new Date();
        return (
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate()
        );
    };

    const hasNoDeadline = (dateStr) => !isValidDate(dateStr);
    const isPast = (dateStr) => {
        if (!isValidDate(dateStr)) return false;
        const date = new Date(dateStr);
        const now = new Date();
        return date < now && !isToday(dateStr);
    };

    const categoryTaskCount = flatData.reduce((acc, task) => {
        const categoryKey = task?.category?.toLowerCase()?.replace(/\s+/g, "_");
        if (categoryKey) {
            acc[categoryKey] = (acc[categoryKey] || 0) + 1;
        }
        return acc;
    }, {});

    const summary = [
        {
            id: "today_tasks",
            labelname: "Today",
            count: flatData.filter((task) => isToday(task.StartDate)).length,
        },
        {
            id: "new_tasks",
            labelname: "New",
            count: flatData.filter((task) => task.isnew === 1).length,
        },
        {
            id: "due_tasks",
            labelname: "Due",
            count: flatData.filter((task) => isPast(task.DeadLineDate)).length,
        },
        {
            id: "UnsetDeadline_tasks",
            labelname: "Unset Deadline",
            count: flatData.filter((task) => hasNoDeadline(task.DeadLineDate)).length,
        },
        ...(Array.isArray(taskCategory)
            ? taskCategory.map((label) => {
                const key = label?.labelname?.toLowerCase()?.replace(/\s+/g, "_");

                return {
                    id: label.id,
                    labelname: label.labelname,
                    count: categoryTaskCount[key] || 0,
                };
            })
            : []),
    ];
    return summary;
};

export const isValidTaskNo = (taskNo) => {
    if (taskNo == null) return false;
    const cleaned = String(taskNo).trim().toLowerCase();
    return (
        cleaned !== "" &&
        cleaned !== "0" &&
        cleaned !== "null" &&
        cleaned !== "undefined"
    );
};


export const filterTasksByValidTaskNo = (tasks = []) => {
    if (!Array.isArray(tasks)) return [];
    return tasks
        .map(task => {
            const filteredSubtasks = filterTasksByValidTaskNo(task.subtasks || []);
            const validTaskNo = isValidTaskNo(task?.taskno);
            const isValidTask = validTaskNo && task?.parentid != 0;
            if (!isValidTask && filteredSubtasks.length === 0) return null;

            return {
                ...task,
                subtasks: filteredSubtasks,
            };
        })
        .filter(Boolean);
};

export const filterNestedTasksByView = (tasks = [], mode = 'me', userId) => {
    return tasks
        ?.map((task) => {
            const isCreatedByMe = task?.createdbyid == userId;
            const isAssignedToMe = task?.assignee?.some((ass) => ass.id == userId);
            const hasAssignees = !!task?.assigneids?.trim();
            const isMyTask = isCreatedByMe && isAssignedToMe && hasAssignees;
            const isTeamTask = !isMyTask;
            const isCreatedByMeAssignedToOthers = isCreatedByMe && !isAssignedToMe && hasAssignees;

            const filteredSubtasks = task?.subtasks
                ? filterNestedTasksByView(task.subtasks, mode, userId)
                : [];

            let shouldInclude = false;

            if (mode === 'me') {
                shouldInclude = isMyTask;
            } else if (mode === 'team') {
                shouldInclude = true; // Show all tasks in team mode
            } else if (mode === 'createdby') {
                shouldInclude = isCreatedByMeAssignedToOthers;
            }

            if (shouldInclude || filteredSubtasks.length > 0) {
                return {
                    ...task,
                    subtasks: filteredSubtasks,
                };
            }

            return null;
        })
        .filter(Boolean);
};

export function mergeFilterGroups(attributesData, groupsData, mappingData) {
    const attributeMap = new Map(attributesData.map(attr => [attr.id, attr]));

    const groupMap = new Map(groupsData.map(group => [
        group.id,
        { id: group.id, filtergroup: group.filtergroup, attributes: [] }
    ]));

    mappingData.forEach(({ filtergroupid, filterattrid }) => {
        const group = groupMap.get(filtergroupid);
        const attr = attributeMap.get(filterattrid);

        if (group && attr && !group.attributes.some(a => a.id === attr.id)) {
            group.attributes.push(attr);
        }
    });

    return Array.from(groupMap.values());
}

function mergeFilterData(maingroups, groups, attributes, bindings) {
    const mainGroupMap = new Map(maingroups?.rd.map(({ id, filtermaingroup }) => [id, filtermaingroup || ""]));
    const groupMap = new Map(groups?.rd.map(({ id, filtergroup }) => [id, filtergroup || ""]));
    const attrMap = new Map(attributes?.rd.map(({ id, filterattr }) => [id, filterattr || ""]));
    const structure = new Map();
    for (const { id: bindid, filtermaingroupid, filtergroupid, filterattrid } of bindings?.rd || []) {
        if (!structure.has(filtermaingroupid)) {
            structure.set(filtermaingroupid, {
                id: filtermaingroupid,
                name: mainGroupMap.get(filtermaingroupid) || "",
                groups: new Map()
            });
        }
        const mainGroup = structure.get(filtermaingroupid);
        if (!mainGroup.groups.has(filtergroupid)) {
            mainGroup.groups.set(filtergroupid, {
                id: filtergroupid,
                name: groupMap.get(filtergroupid) || "",
                attributes: []
            });
        }
        const group = mainGroup.groups.get(filtergroupid);
        const rawAttrName = attrMap.get(filterattrid) || "";
        const attrNames = rawAttrName
            .split(',')
            .map(a => a.trim())
            .filter(a => a !== "");
        for (const name of attrNames) {
            const alreadyExists = group.attributes.some(attr => attr.name === name && attr.id === filterattrid);
            if (!alreadyExists) {
                group.attributes.push({
                    id: filterattrid,
                    name,
                    bindid
                });
            }
        }
    }

    return Array.from(structure.values()).map(mainGroup => ({
        ...mainGroup,
        groups: Array.from(mainGroup.groups.values())
    }));
}


// status change
export const handleAddApicall = async (updatedTasks) => {
    let rootSubrootflagval = { "Task": "root" }
    const addTaskApi = await AddTaskDataApi(updatedTasks, rootSubrootflagval ?? {});
    if (addTaskApi?.rd[0]?.stat == 1) {
        toast.success(addTaskApi?.rd[0]?.stat_msg);
    }
}

export const background = (assignee) => {
    const avatarBackgroundColor = assignee?.avatar
        ? "transparent"
        : getRandomAvatarColor(assignee);
    return avatarBackgroundColor;
};

export const Datetheme = createTheme({
    palette: {
        primary: {
            main: "#7367f0",
        },
        secondary: {
            main: "#f50057",
        },
        background: {
            default: "#f5f5f5",
        },
    },
    typography: {
        color: "#fff !important",
        fontFamily: '"Public Sans", sans-serif',
        h4: {
            fontWeight: 600,
        },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: "rgba(90, 90, 90, 0.1) 0px 4px 12px",
                    border: "1px solid rgba(90, 90, 90, 0.1)",
                    "&::-webkit-scrollbar": {
                        width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                        background: "transparent", // Almost invisible track
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(0, 0, 0, 0.1)", // Very light thumb
                        borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.15)", // Slightly visible on hover
                    },
                    "&::-webkit-scrollbar-thumb:active": {
                        backgroundColor: "rgba(0, 0, 0, 0.2)", // Slightly darker when dragging
                        color: "#fff",
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    textTransform: "capitalize",
                },
                containedPrimary: {
                    background: "linear-gradient(270deg, rgba(115, 103, 240, 0.7) 0%, #7367f0 100%)", // Button color
                    "&:hover": {
                        background: "linear-gradient(270deg, rgba(115, 103, 240, 0.7) 0%, #7367f0 100%)",
                    },
                    color: "white",
                },
                textSecondary: {
                    background: "#ebebed", // Button color
                    "&:hover": {
                        backgroundColor: "#ebebed",
                    },
                    color: "#7D7f85",
                }
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    borderRadius: 8, // Applies border radius to the entire TextField
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            borderColor: "gray", // Default border color (gray)
                        },
                        "&:hover fieldset": {
                            borderColor: "black", // Darker border on hover
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "#1976d2", // Default MUI blue when focused
                        },
                        "&.Mui-disabled fieldset": {
                            borderColor: "#d1d1d1", // Light gray when disabled
                        },
                        "&.Mui-error fieldset": {
                            borderColor: "#d32f2f", // Red border when there's an error
                        },
                    },
                    "& .MuiInputBase-input": {
                        padding: "10px 14px", // Padding inside the input field
                    },
                    "& .MuiInputLabel-root": {
                        color: "gray", // Default label color
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                        color: "#1976d2", // Label color when focused
                    },
                    "& .MuiInputLabel-root.Mui-error": {
                        color: "#d32f2f", // Label color when there's an error
                    },
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    maxHeight: "200px", // Fixed height for the dropdown list
                    overflowY: "auto", // Enable vertical scrolling if content exceeds height
                    zIndex: 1300, // Ensure proper z-index for overlay elements
                },
            },
        },
    },
});

export const renderAssigneeAvatars = (assignees, hanldePAvatarClick) => (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <AvatarGroup
            max={6}
            spacing={2}
            sx={{
                '& .MuiAvatar-root': {
                    width: 30,
                    height: 30,
                    fontSize: '0.8rem',
                    cursor: 'pointer',
                    border: 'none',
                    transition: 'transform 0.3s ease-in-out',
                    '&:hover': {
                        transform: 'scale(1.2)',
                        zIndex: 10,
                    },
                },
            }}
        >
            {assignees?.map((assignee, teamIdx) => (
                <Tooltip
                    placement="top"
                    key={assignee?.id}
                    title={`${assignee?.firstname} ${assignee?.lastname}`}
                    arrow
                    classes={{ tooltip: 'custom-tooltip' }}
                >
                    <Avatar
                        key={teamIdx}
                        alt={`${assignee?.firstname} ${assignee?.lastname}`}
                        src={ImageUrl(assignee) || null}
                        sx={{
                            backgroundColor: background(`${assignee?.firstname + " " + assignee?.lastname}`)
                        }}
                        onClick={() => hanldePAvatarClick(assignees, assignee?.id)}
                    >
                        {!assignee.avatar && assignee?.firstname?.charAt(0)}
                    </Avatar>
                </Tooltip>
            ))}
        </AvatarGroup>
    </Box>
);

// Helper function to format days display
export const formatDaysDisplay = (deadlineDate, task) => {
    const days = getDaysFromDeadline(deadlineDate);

    if (days === null || !cleanDate(deadlineDate)) {
        return <span>-</span>;
    }

    const formattedDate = formatDate2(deadlineDate);

    const isCompleted = task?.status?.toLowerCase() === 'completed' || task?.progress_per === 100;

    let chipColor, chipBgColor, displayText;

    if (isCompleted) {
        if (task?.EndDate && cleanDate(task?.EndDate)) {
            const endDate = new Date(task.EndDate);
            const deadline = new Date(deadlineDate);
            const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
            const deadlineOnly = new Date(deadline.getFullYear(), deadline.getMonth(), deadline.getDate());

            if (endDateOnly.getTime() === deadlineOnly.getTime()) {
                chipColor = '#388e3c';
                chipBgColor = '#dcedc8';
                displayText = 'On Time';
            } else if (endDateOnly < deadlineOnly) {
                const diffMs = deadlineOnly - endDateOnly;
                const daysEarly = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                chipColor = '#388e3c';
                chipBgColor = '#dcedc8';
                displayText = `${daysEarly} days early`;
            } else {
                const diffMs = endDateOnly - deadlineOnly;
                const daysLate = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                chipColor = '#d32f2f';
                chipBgColor = '#ffcdd2';
                displayText = `${daysLate} days late`;
            }
        } else {
            chipColor = '#388e3c';
            chipBgColor = '#dcedc8';
            displayText = 'Completed';
        }
    } else if (days < 0) {
        chipColor = '#d32f2f';
        chipBgColor = '#ffcdd2';
        displayText = `${Math.abs(days)} days overdue`;
    } else if (days === 0) {
        chipColor = '#388e3c';
        chipBgColor = '#dcedc8';
        displayText = 'Today';
    } else {
        chipColor = '#1976d2';
        chipBgColor = '#bbdefb';
        displayText = `${days} days`;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px' }}>
            <span style={{ fontSize: '13px', lineHeight: '1.2' }}>{formattedDate}</span>
            <Chip
                label={displayText}
                size="small"
                sx={{
                    backgroundColor: chipBgColor,
                    color: chipColor,
                    fontSize: '10px',
                    height: '16px',
                    '& .MuiChip-label': {
                        padding: '0 4px',
                        fontWeight: '500'
                    }
                }}
            />
        </div>
    );
};

export const getClientIpAddress = async () => {
    try {
        const cachedIp = sessionStorage.getItem("clientIpAddress");
        if (cachedIp) return cachedIp;

        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        const ip = data?.ip || "";

        sessionStorage.setItem("clientIpAddress", ip);
        return ip;
    } catch (error) {
        console.error("Error fetching IP address:", error);
        return "";
    }
};

// Get user location coordinates
export const getLocation = async () => {
    return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
            (pos) => resolve({
                Latitude: pos.coords.latitude.toString(),
                Longitude: pos.coords.longitude.toString(),
            }),
            () => resolve({ Latitude: "", Longitude: "" })
        );
    });
};

// Get comprehensive device information
export const DeviceInfo = async () => {
    const parser = new UAParser();
    const ua = parser.getResult();

    let deinfo = {
        DeviceOS: ua.os.name,
        DeviceOSVersion: ua.os.version,
        BrowserName: ua.browser.name,
        BrowserVersion: ua.browser.version,
        DeviceType: ua.device.type || 'desktop',
        CpuCore: navigator.hardwareConcurrency || "",
        DeviceMemory: navigator.deviceMemory,
        ScreenHeight: window.screen.height,
        ScreenWidth: window.screen.width,
        Language: navigator.language,
        TimezoneOffset: new Date().getTimezoneOffset(),
        DoNotTrack: navigator.doNotTrack || "unknown",
        UserAgent: navigator?.userAgent || "",
        authtoken: "",
        UserId: "",
        RequestToken: "",
        RefreshToken: "",
        DeviceToken: "",
        sv: "",
        version: "",
        IPAddress: await getClientIpAddress(),
        ...(await getLocation())
    }
    const deviceString = Object.values(deinfo).join("|");
    const hash = btoa(deviceString).substring(0, 32);
    deinfo.FingerPrint = hash;
    
    return deinfo;
};




